import { useEffect } from 'react';

import { RunningExperiments, useExperiments } from 'state/experiments';

const TREATMENT_VARIANT = 'treatment';

/**
 * Reads the Remove Menu Favorites experiment without logging exposure.
 * Returns `undefined` while the assignment is unresolved: callers must treat
 * that as "not yet known", not as a guessed true/false, so they can hide the
 * gated UI instead of rendering a guess that a moment later gets corrected.
 *
 * A login/logout identity transition clears the cached assignment while it
 * refetches. Keep the result unresolved through that transition (and a fetch
 * failure) so the experiment's presentation can remain neutral rather than
 * render a stale or guessed variant.
 */
export const useRemoveMenuFavoritesExperiment = (): boolean | undefined => {
  const { variant, isAssignmentLoading, hasAssignmentFetchFailed } = useExperiments();

  if (isAssignmentLoading || hasAssignmentFetchFailed) {
    return undefined;
  }

  return variant(RunningExperiments.RemoveMenuFavorites, TREATMENT_VARIANT, {
    skipExposureLogging: true,
  });
};

export const useExposeRemoveMenuFavoritesExperiment = (shouldExpose = true) => {
  const { logExposure } = useExperiments();

  useEffect(() => {
    if (!shouldExpose) {
      return;
    }

    logExposure(RunningExperiments.RemoveMenuFavorites);
  }, [shouldExpose, logExposure]);
};
